import { extendTheme } from '@chakra-ui/react';
import { Card } from './Card';
import { Box } from './Box';
import { InputFrame } from './InputFrame';
import { Heading } from './Heading';
import { Colors } from './colors';

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#FAFAFA',
        color: '#2b2b2b',
      },
    },
  },
  colors: {
    greenBarChart: {
      100: Colors.greenBar,
      200: Colors.greenBar,
      300: Colors.greenBar,
      400: Colors.greenBar,
      500: Colors.greenBar,
      600: Colors.greenBar,
      700: Colors.greenBar,
      800: Colors.greenBar,
      900: Colors.greenBar,
      normal: Colors.greenBar,
      active: Colors.greenBar,
      hover: Colors.greenBar,
    },
    brand: {
      100: '#F9FBFE',
      200: '#E5EFFE',
      300: '#8EB8FC',
      400: '#619BFB',
      500: '#347EF9',
      600: '#0762F8',
      700: '#0347B6',
      800: '#012D75',
      900: '#001433',
      normal: '#0762F8',
      active: '#0347B6',
      hover: '#347EF9',
    },
  },
  fonts: {
    heading: '"Lato", sans-serif',
    body: '"Lato", sans-serif',
  },
  components: {
    Card,
    Box,
    InputFrame,
    Heading,
  },
});

/*
const theme = extendTheme(
  {
    styles: {
      global: {
        body: {
          // bg: "#E5E5E5"
          bg: '#EFEFEF',
        },
      },
    },
    colors: {
      brand: {
        100: '#F9FBFE',
        200: '#E5EFFE',
        300: '#8EB8FC',
        400: '#619BFB',
        500: '#347EF9',
        600: '#0762F8',
        700: '#0347B6',
        800: '#012D75',
        900: '#001433',
        normal: '#0762F8',
        active: '#0347B6',
        hover: '#347EF9',
      },
    },
    components: {
      Card,
    },
  },
  withDefaultColorScheme({
    colorScheme: 'brand',
  })
);
*/
export default theme;
